import { render, staticRenderFns } from "./LcaProgress.vue?vue&type=template&id=70dbb8a7&scoped=true"
import script from "./LcaProgress.vue?vue&type=script&lang=js"
export * from "./LcaProgress.vue?vue&type=script&lang=js"
import style0 from "./LcaProgress.vue?vue&type=style&index=0&id=70dbb8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dbb8a7",
  null
  
)

export default component.exports